import { useGetInvoicesQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { useGetInvoicesQuery as usePreviewGetInvoicesQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewDataRpc.hooks';
import { useAppSelector } from '../redux';
import { selectIsPreview, selectPreviewJwt } from '../features/PreviewSlice/PreviewSelectors';
export function useInvoicesData(variables, overrides = {}) {
  var _useAppSelector;
  const isPreview = useAppSelector(selectIsPreview);
  const previewJwt = (_useAppSelector = useAppSelector(selectPreviewJwt)) !== null && _useAppSelector !== void 0 ? _useAppSelector : '';
  const {
    loading: previewLoading,
    error: previewError,
    data: previewData
  } = usePreviewGetInvoicesQuery({
    variables: Object.assign({
      previewJwt
    }, variables),
    skip: !isPreview
  });
  const {
    loading,
    error,
    data,
    previousData
  } = useGetInvoicesQuery(Object.assign({
    variables,
    skip: isPreview,
    // On every mount (including returning from invoice details), fire a background
    // network request while immediately returning cached data.
    fetchPolicy: 'cache-and-network',
    // When variables change (pagination), use cache-first so previously loaded
    // pages don't trigger a network call. For 'after-fetch', return currentFetchPolicy
    // (cache-and-network) so remounts continue to make a network call.
    nextFetchPolicy: (currentFetchPolicy, {
      reason
    }) => {
      if (reason === 'variables-changed') {
        return 'cache-first';
      }
      return currentFetchPolicy;
    }
  }, overrides));
  if (isPreview) {
    return {
      loading: previewLoading,
      error: previewError,
      data: previewData
    };
  }
  return {
    loading,
    error,
    data: data !== null && data !== void 0 ? data : previousData === null || previousData === void 0 ? void 0 : previousData.result
  };
}